<template>
  <el-container class="container" ref="homePage">
    <el-header class="header" style="height: 70px;">
      <div class="logo_container">
        <a href="http://www.jinshisoft.com/" target="_blank"><img :src="logo" class="logo" /></a>
      </div>
      <div class="top_menu">
        <a href="/" target="_blank" style="text-decoration: transparent;">{{AppName}}</a>
      </div>
			<div class="tianqi">
				<!-- <iframe width="100%" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=35&h=55&w=200"></iframe> -->
			  <iframe width="210" scrolling="no" height="60" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=12&color=%23333333&icon=1&num=1&site=12"></iframe>
			</div>
			<div class="search">
				<el-input placeholder="请输入要搜索的内容" v-model="keyword" class="input-with-select" @keyup.enter.native="Search" >
				    <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
				  </el-input>
			</div>
			
    </el-header>
    <el-container class="main">
      <el-aside class="menu-container menu-expanded" :style="'height: ' + height + 'px;'">
        <el-tree
          :data="data"
          checkbox
          node-key="ID"
          :default-expand-all="expandAll"
          :expand-on-click-node="true"
          :default-expanded-keys="expandedKeys"
          ref="tree"
          style="width: 100%; padding-left: 10px;"
          @node-click="getNode"
          :filter-node-method="filterNode"
          highlight-current
					
          >
          <span class="custom-tree-node" slot-scope="{ node, data }" :class="checked? 'chkw':''">
						<span v-if="data.type=='0'" class="mulu">
						  <span>
						    <img src="/static/images/folder-open.png" class="node-icon" v-if="node.expanded==true" />
						    <img src="/static/images/folder.png" class="node-icon" v-else />
						    {{ data.目录名称 }}
						  </span>
							
						</span>
						<span v-if="data.type == '1'" class="subject" :title="data.标题">
						  <a :href="'/view/' + data.ID" style="text-decoration: transparent; color: #333333;">
						  	<i class="el-icon-s-order node-icon-2" style="margin-right: 0px;" alt="1"></i>
						  {{ data.标题 }}
							<!-- <span v-if="data.带视频=='1'" class="ri-live-line" style="font-size: 18px; vertical-align: bottom;"></span> -->
							<span v-if="data.带视频=='1'"><img src="../assets/camera.png" height="14"></span>
						  </a>
						</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main class="content-container" ref="main" :style="'height: ' + height + 'px;'">
        <div class="container2">
					<div class="left">
						<div class="path" v-html="currentPath"></div>
						<div class="content" v-html="content"></div>
					</div>
					<div class="right">
						<el-tabs tab-position="right" style="width: 240px;position: fixed; top: 80px; right: 10px;" @tab-click="clickTab" >
						    <el-tab-pane v-for="(item,index) in anchorList" :label="item.锚点名称" :name="item.锚点ID" :key="index"></el-tab-pane>
						    
						  </el-tabs>
					</div>
				</div>
      </el-main>
    </el-container>
  </el-container>


</template>

<script>
  import { mapMutations } from 'vuex';
  import * as util from '@/utils/util.js';

  let _ = require('lodash')

  export default {
    components: {
      
    },
    data() {
      return {
        AppName: '帮助文档',
        logo: require('../assets/czylogo.png'),
        data: [],
        content: '',
				filterText: '',
				expandAll: false,
				expandedKeys: ['0'],
				checked: false,
				currentPath: '',
				AppID: '',
				height: 600,
				anchorList: [],
				keyword: '',
				
      }
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      getNode(data) {
        let node = this.$refs.tree.getCurrentNode();
        if(node!==null && node!==undefined)
        {
					if(node.标题){
						//this.getHelpWenDangInfo(node.ID);
						
						this.go('/view/' + node.ID);
					}
          
        }
      
      },
      Search(){
      	//console.log('this.keyword', this.keyword);
      	
      	if(this.keyword){
      		//this.$router.push({path: 'search/' + this.AppID + '/' + encodeURIComponent(this.keyword)});
      		
      		window.open('/search/' + this.AppID + '/' + encodeURIComponent(this.keyword), 'search');
      	}
      },
			GetHelpWenDangList(UUID){
      	let url="/Handler/Help.ashx?mode=GetHelpWenDangList";
      	this.$ajax.post(url,{UUID: UUID}).then((response)=>{
      	  //console.log(response.data);
      	  //console.log(JSON.stringify(response.data));
      	  let errorCode=response.data.errorCode;
      	  if(errorCode=='0')
      	  {
      	    this.data = response.data.data;
      	    
						this.$nextTick(()=>{
							this.$refs.tree.setCurrentKey(this.currentID);
						})
      	  }
      	  
      	});
      	
      },
			getHelpWenDangInfo(UUID){
				let url="/Handler/Help.ashx?mode=GetHelpWenDangInfo";
				this.$ajax.post(url,{UID: UUID}).then((response)=>{
				  //console.log(response.data);
				  //console.log(JSON.stringify(response.data));
				  let errorCode=response.data.errorCode;
				  if(errorCode=='0')
				  {
				    if(response.data.data.length>0){
							this.currentPath=response.data.data[0].path;
							this.content=response.data.data[0].内容;
							
							this.content=this.content.replace(/<img/g, '<img preview="1" title="点击查看大图"');
							
							document.title=response.data.data[0].标题 + ' | 金石财筑云帮助文档';
							
							this.AddMeta('keywords', '金石,财筑云,金石软件,项目管理软件,工程管理软件,施工管理软件,工程项目管理软件,建筑软件,投资项目管理软件,建设项目管理软件,基建管理软件 ' + response.data.data[0].标题 + ' | 金石财筑云帮助文档');
							this.AddMeta('description', '财筑云工程项目管理软件是在建筑工地管理系统基础之上研发的一款新软件,是东营金石软件公司根据众多施工企业的实际需求精心设计,专业打造的实用,性价比高的工程项目软件。与国内其它施工管理软件相比，财筑云工程项目软件具有：界面直观、操作简单、流程灵活等特点，基于协同办公、预算管理、过程管理、成本管理、账务管理、财务管理等众多功能于一身的工程项目软件，能帮助施工企业实现信息化、方便对施工项目管理实时管控。' + response.data.data[0].标题 + ' | 金石财筑云帮助文档');
							
							
							this.anchorList=response.data.data2;
							
							if(this.AppID!=response.data.data[0].AppUID){
								this.AppID = response.data.data[0].AppUID;
								//this.AppName = response.data.data[0].AppName + '帮助文档';
								
								this.GetHelpWenDangList(this.AppID);
								
							}
							
							this.currentPath='<a href="/">首页</a><span style="padding: 0 5px; color: #CCCCCC;">></span>' + this.currentPath.replace(/>/g, '<span style="padding: 0 5px; color: #CCCCCC;">></span>');
							
							
							this.$nextTick(() => {
								let t = setTimeout(() => {
									this.$previewRefresh();
									
									let href= window.location.href || '';
									
									if(href.indexOf('#')>0){
										let archor=href.substring(href.indexOf('#')+1);
										
										this.clickTab({name: archor});
									}
									
									clearTimeout(t);
								}, 150);
							
							});
						}
				  }
				  
				});
				
			},
      go(path){
         //console.log(path);
         this.$router.push({path: path});
         //this.$router.replace(path);
       },
			calcHeight(){
				this.height=this.clientHeight-70;
				
				console.log('this.clientHeight', this.clientHeight);
			},
			clickTab(tab, event){
				//console.log(tab.name);
				 
				location.href='#'+tab.name;
			 },
			 AddMeta(name, content){
				 let meta = document.querySelector('meta[name="' + name + '"]');
				 
				 if (!meta) {
				   meta = document.createElement('meta');
				   meta.name = name;
				   document.head.appendChild(meta);
				 }
				 
				 meta.setAttribute('content', content);
				 

			 }
    },
		async created(){
			this.currentID=this.$route.params.uuid;
			
			this.expandedKeys.push(this.currentID);
			
			//console.log('$route.params', this.$route.params, window.location.href);
			
			await this.getHelpWenDangInfo(this.currentID);
			
			if(this.AppID){
				this.GetHelpWenDangList(this.AppID);
				
			}
		},
    mounted(){
			
      this.$nextTick(() => {
				
        this.calcHeight();
				/*
				// 禁用鼠标右键菜单
				document.addEventListener('contextmenu', function(e) {
						e.preventDefault();
						return false;
				});
				
				// 禁用键盘按键（F12 及常见开发者工具快捷键）
				document.addEventListener('keydown', function(e) {
					// 禁用 F12
					if (e.key === 'F12' || e.keyCode === 123) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+I (开发者工具)
					if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+J (控制台)
					if (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+C (元素选择器)
					if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+U (查看源代码)
					if (e.ctrlKey && (e.key === 'U' || e.key === 'u')) {
							e.preventDefault();
							return false;
					}
				});
				//屏蔽复制
				document.oncopy = function (event) {
					if (window.event) {
						event = window.event;
					} 
					try {
						var the = event.srcElement;
						if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA"))
						{
							return false;
						}
						return true;
					} catch (e) {
						return false;
					}
				}
				//屏蔽选中
				document.onselectstart = function (event) {
					if (window.event) {
						event = window.event;
					}
					try {
							var the = event.srcElement;
							if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
								return false;
							}
							return true;
					}
					catch (e) {
						return false;
					}
				}
				*/
      });
      
			
    },
    destroyed() {
      //window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
      //window.removeEventListener('unload', e => this.unloadHandler(e))
    },
		watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        //console.log('watch:',this.clientHeight);
				
				this.calcHeight();
				
      },
			'$route.params.uuid'(val, oldVal){
				
				if(oldVal){
					this.currentID=this.$route.params.uuid;
					
					this.getHelpWenDangInfo(this.currentID);
				}
				
			}
    },
    computed: {
      closingPage () {
        return this.$store.state.closingPage
      },
			clientHeight(){
				return document.documentElement.clientHeight;
			}
    }
  }
</script>

<style lang="scss" scoped="scoped">
  .el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 180px;
		background-color: #fafafa;
	}
	.el-menu--collapse {
		overflow: hidden;
		width: 44px;
	}
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		height: 100%;
		border: 0px solid #F00;
		overflow-y: auto;
		.header {
			padding: 0;
			height: 70px;
			line-height: 70px;
			// background-color: #3389e0;
			background-color: #43b6c8;
			background-color: #ffffff;
			border-bottom: 1px solid #377a84;
			border-bottom: 3px solid #eeeeee;
			color: #666666;
			font-size: 25px;
			text-align: left;
			.logo_container {
				float: left;
				border: 0px solid #FF0000;
				width: 150px;
				// background-color: #1271d0;
				// background-color: #377a84;
				text-align: center;
				.logo {
					margin: 0 auto;
					width: 100px;
					border: 0px solid #FF0000;
					vertical-align: middle;

				}
				
			}
			.title{
				font-family: 微软雅黑;
				float: left;
				font-size: 24px;
				padding-left: 20px;
				border: 0px solid #F00;
				letter-spacing: 5px;
			}
			.top_menu {
			  float: left;
			  border: 0px solid #FF6600;
				padding-left: 20px;
			  height: 70px;
			  
			}
			.search{
				float: right;
			  margin-top: 0px;
				margin-right: 50px;
			  width: 300px;
			  height: 70px;
			  overflow: hidden;
			}
			.tianqi{
				float: right;
			  margin-top: 5px;
			  width: 210px;
			  height: 60px;
			  overflow: hidden;
			}
		}
		.main {
			padding-left: 0;
			// display: flex;
			position: relative;
			// top: 0px;
			// bottom: 0px;
			width: 100%;
			.menu-container {
				//padding: 10px;
				// flex: 0 0 200px;
				width: 120px;
				//background-color: #333c4b;
				background-color: #344772;
				background-color: #424256;
				background-color: #f1f4f8;
				text-align: left;
				overflow-x: hidden;
				overflow-y: auto;
				border-right: 1px solid #DDDDDD;
				
			}
			.menu-collapsed{
				flex:0 0 50px;
				width: 50px;
			}
			.menu-expanded{
				flex:0 0 300px;
				width: 300px;
				padding-top: 0px;
			}
			.menu-expanded::-webkit-scrollbar {
			  /*滚动条整体样式*/
			  display: none;
			}
			.content-container {
				padding: 0;
				padding-top: 0px;
				flex: 1;
				height: 100%;
				overflow-y: auto;
				background-color: #F7F8F9;
				background-color: #FFFFFF;
				position: relative;
				text-align: left;
				.container2{
					margin: 0 auto;
					padding: 10px 20px;
					min-width: 1040px;
					text-align: left;
					display: flex;
					
					.right{
						flex: 0 0 200px;
						width: 200px;
					}
				}
			}
		}
	}
	.path{
		height: 60px;
		line-height: 50px;
		font-size: 16px;
		color: #666666;
	}
	.content{
		text-align: left;
		font-size: 16px;
		line-height: 180%;
		overflow-x: auto;
	}
	.mulu{
		color: #333333;
		font-weight: bold;
		img{
			border: 0 solid #FFFFFF;
		}
	}
	.subject{
		color: #333333;
	}
  input::-webkit-input-placeholder {
    color: #FFFFFF;
    font-size: 14px;
  }
  
  input:-moz-placeholder {
    color: #FFFFFF;
    font-size: 14px;
  }
  
  input::-moz-placeholder {
    color: #FFFFFF;
    font-size: 14px;
  }
  
  input:-ms-input-placeholder {
    color: #FFFFFF;
    font-size: 14px;
  }
	/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	  background-color: #3399ff;
	  background-color: #eeeeee;
	  color: #414e5f;
	  // color: #ffffff;
	}
	/deep/ .el-tree-node__content{
		height: 40px;
		line-height: 40px;
	}
	/deep/ .custom-tree-node{
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
  /deep/ .el-tree-node__expand-icon{
  	color: #000000;
  	font-size: 16px;
  }
	/deep/ .el-tree-node__expand-icon.is-leaf{
		color: transparent;
	}
	/deep/ .el-tabs__item{
		height: 30px;
		line-height: 30px;
		font-size: 16px;
	}
	/deep/ .el-tabs--right .el-tabs__header.is-right{
		width: 200px;
	}
	/deep/ .el-icon-search:before{
		font-size: 22px;
	}
</style>
<style>
	.content img{
		margin: 10px 0;
		max-width: 96%;
		height: auto !important;
		border: 0px solid #DDDDDD;
		cursor: pointer;
	}
	video{
		max-width: 96%;
	}
	.content div{
		text-indent: 0px;
	}
	.content p{
		text-indent: 0px;
	}
	.content li{
		text-indent: 0px;
	}
</style>